export default __webpack_public_path__ + "static/media/chev-right.2b6fe08e.svg";